import React, { useCallback, useEffect, useState } from 'react';
import { Loader } from '../../../../../UiKit';
import { EmptyState } from '../../../../commons';
import ActionOptions from '../../ActionOptions/ActionOptions';
import SuccessScreen from '../../ActionOptions/SuccessScreen';
import { InvalidSearchImg } from '../../../../../images/images';
import { reasonModel } from '../../../../../api';

function PendingIssues({
  orderId,
  cartId,
  userId = null,
  complaintType,
  complaintId,
  preSelectedItems,
  goBack,
}) {
  const [resolutionSuccessDetails, setResolutionSuccessDetails] =
    useState(null);
  const [resolutionOptionDetails, setResolutionOptionDetails] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMsg] = useState(null);

  const errorHandler = () => {
    setLoading(false);
    setError(true);
    setErrorMsg('Something went wrong');
  };

  useEffect(() => {
    const evaluate = () => {
      const dataForEvaluate = {
        order_id: orderId,
        cart_id: cartId,
        complaint_type: complaintType,
        complaint_id: complaintId,
        is_approved_complaint: true,
      };

      setLoading(true);
      return reasonModel
        .evaluateResolution(dataForEvaluate)
        .then((response) => {
          if (!response) return null;
          if (response && response.isError === true) {
            errorHandler();
          } else {
            setLoading(false);
            setResolutionOptionDetails(response);
          }
          return response;
        })
        .catch((err) => {
          errorHandler();
        });
    };
    evaluate();
  }, [orderId, cartId, complaintType]);

  const resolve = useCallback(
    (resolutionOption) => {
      const dataForResolve = {
        order_id: orderId,
        complaint_id: resolutionOptionDetails?.complaint_id,
        resolution: resolutionOption?.resolution,
        sub_resolution: resolutionOption?.sub_resolution || null,
        cart_id: cartId,
        complaint_type: complaintType,
        selected_items: preSelectedItems,
        is_approved_complaint: true,
      };
      setLoading(true);
      return reasonModel
        .createResolution(dataForResolve)
        .then((response) => {
          if (!response) return null;

          if (response && response.isError === true) {
            errorHandler();
          } else {
            setLoading(false);
            setResolutionSuccessDetails(response);
          }
          return response;
        })
        .catch((err) => {
          errorHandler();
        });
    },
    [orderId, cartId, complaintType, resolutionOptionDetails],
  );

  if (isLoading) return <Loader />;
  if (isError)
    return <EmptyState img={InvalidSearchImg} heading={errorMessage} />;
  return (
    <div className='raiseIssueContainer'>
      {resolutionSuccessDetails ? (
        <SuccessScreen details={resolutionSuccessDetails} goBack={goBack} />
      ) : (
        <div className='raiseIssueContent'>
          <ActionOptions
            PendingIssuesFlow={true}
            resolutionOptionDetails={resolutionOptionDetails}
            resolve={resolve}
            isDisabled={isLoading}
            complaintType={complaintType}
            orderId={orderId}
            cartId={cartId}
            userId={userId}
          />
        </div>
      )}
    </div>
  );
}

export default PendingIssues;
